<template>
   <div class="bg-loading" v-if="isLoaderActive">
      <h4 class="title-loading" v-if="loaderText">{{loaderText}}</h4>
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status"></div>
   </div>
</template>

<script>
export default {
   name: "Loader",
   computed: {
      loaderText(){
         return this.$store.state.loaderText;
      },
      isLoaderActive(){
         return this.$store.state.isLoaderActive;
      },
   }
}
</script>

<style scoped>
   .bg-loading {
      background: rgba(255, 255, 255, 0.7);
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 300000;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      flex-direction: column;
      transition: all .3s ease;
   }

   .title-loading {
      position: relative;
      padding: 5px;
   }
</style>